module.exports = __webpack_public_path__ + "img/finger-down.b8a8027e.svg";